'use client'

import { MultiChoiceWordQuestion } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'
import { clsx } from 'clsx'
import React from 'react'
import { match } from 'ts-pattern'

import { ChipV2, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  question: MultiChoiceWordQuestion
  value: Undefinable<string>
  handleChangeCurrentFunnelValue: (value: string) => void
}

export const EnglishMultiChoiceWordQuizFunnel = ({ question, value, handleChangeCurrentFunnelValue }: Props) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <Typography size="h1" className="py-5 text-[22px] font-bold">
        {question.source.body.vocab}
      </Typography>
      <VStack className="gap-2">
        <Typography size="h6" className="text-gray-400">
          {t('lesson.quiz.answer')}
        </Typography>

        {question.source.body.options.map((option, index) => (
          <ChipV2
            key={option}
            selected={index.toString() === value}
            onClick={() => handleChangeCurrentFunnelValue(index.toString())}
            fontWeight="medium"
          >
            {option}
          </ChipV2>
        ))}
      </VStack>
    </React.Fragment>
  )
}

export const JapaneseMultiChoiceWordQuizFunnel = ({
  question,
  contentLevel,
  value,
  handleChangeCurrentFunnelValue,
}: Props & { contentLevel: number }) => {
  const t = useTranslation()

  return (
    <React.Fragment>
      <Typography size="h1" className="py-5 text-[22px] font-bold">
        {match(contentLevel)
          .when(
            // 중급 이상
            (level) => level === 2,
            () =>
              question.source.body.vocab_diction_native_lang
                ? question.source.body.vocab.split('').map((part, index) => {
                    return (
                      <ruby key={`student-sentence-${index}`}>
                        <span>{part}</span>
                        <rp>(</rp>
                        <rt className={clsx(`text-gray-400 text-[11px] font-bold mb-0.5`, '!text-[11px]')}>
                          {question.source.body.vocab_diction_native_lang?.[index]}
                        </rt>
                        <rp>)</rp>
                      </ruby>
                    )
                  })
                : question.source.body.vocab,
          )
          .otherwise(() => question.source.body.vocab)}
      </Typography>
      <VStack className="gap-2">
        <Typography size="h6" className="text-gray-400">
          {t('lesson.quiz.answer')}
        </Typography>

        {question.source.body.options.map((option, index) => (
          <ChipV2
            key={option}
            selected={index.toString() === value}
            onClick={() => handleChangeCurrentFunnelValue(index.toString())}
            fontWeight="medium"
          >
            {option}
          </ChipV2>
        ))}
      </VStack>
    </React.Fragment>
  )
}
